import { createContext, useContext, type ReactNode } from 'react';
import { FF_FPL_MIGRATION } from '@/consts/featureFlags';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';

export const FplMigrationContext = createContext<boolean | undefined>(undefined);

export function FplMigrationProvider({ children }: { children: ReactNode }) {
  const { value } = useFeatureFlag(FF_FPL_MIGRATION);
  return <FplMigrationContext.Provider value={value}>{children}</FplMigrationContext.Provider>;
}

export function useFplMigrationFlag(): boolean {
  return useContext(FplMigrationContext) === true;
}
